import { Center, CenterProps, MantineColor, Loader as MantineLoader } from '@mantine/core'

interface Props extends CenterProps {
  color?: MantineColor
  debugText?: string
}

export default function Loader(props: Props) {
  return (
    <Center h="100%" {...props}>
      <MantineLoader type="dots" size="xl" color={props.color} />
      {props.debugText && <div>{props.debugText}</div>}
    </Center>
  )
}
